<template>
    <!-- 当 menu 的 router attribute 为true时，代表此模块的 vue-router模块打开，点击时跳转到 index 对应的路由地址  -->
    <!-- 采用 router-link 的方式跳转 <el-menu-item index="0-1-1"> <router-link to="/poem">诗词</router-link> </el-menu-item> -->
    <el-menu class="el-menu-demo" mode="horizontal" :router="true">
      <el-submenu index="0-1">
        <template slot="title">诗词</template>
        <el-menu-item index="/poem"> 诗词 </el-menu-item>
        <el-menu-item index="/rhesis"> 名句 </el-menu-item>
      </el-submenu>
      <el-submenu index="0-2">
        <template slot="title">书籍</template>
        <el-menu-item index="/kindle"> 英文 </el-menu-item>
        <el-menu-item index="/kindle"> kindle </el-menu-item>
      </el-submenu>
      <el-submenu index="0-3">
        <template slot="title">工具</template>
        <el-menu-item index="/calendar"> 日历 </el-menu-item>
      </el-submenu>
      <el-menu-item class="iconhead">
          <router-link to="/">
            <img src="@/assets/yeyuqiudeng.jpg" alt="" style="width: 18%">
          </router-link>
      </el-menu-item>
    </el-menu>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
.el-menu-demo {
  width: 100%;
}
.iconhead {
  /* float: right; */
  position: absolute;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Header/Header.vue